/* GOPSHOP 7.17 – Täglicher Drop ist nur noch ein Hinweis (Nutzer-Wunsch 10.10.): oben läuft der Countdown, sonst nichts.
   Produkte, Warenkorb und Kasse sind immer verfügbar – sichtbar ist, was im Admin aktiv ist, unabhängig von der Uhrzeit.
   Einstellungen: Theme-Einstellungen › GOPSHOP › Täglicher Drop (window.gopDrop aus layout/theme.liquid).
   Die Klassen html.gop-drop-open/-closed steuern nur Text und Knöpfe der Hinweis-Leiste (sections/gop-notice.liquid). */
(function () {
  var D = window.gopDrop;
  if (!D || !D.on || /bot|crawl|spider|lighthouse|slurp/i.test(navigator.userAgent)) return;
  var en = !!D.en;
  var root = document.documentElement;
  var START = D.start * 60, LEN = D.hours * 60;
  var FORCE = (location.search.match(/gopdrop=(open|closed)/) || [])[1]; /* nur zum Testen */
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var hhmm = function (min) { min = ((min % 1440) + 1440) % 1440; return pad(Math.floor(min / 60)) + ':' + pad(min % 60); };
  var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });

  function now() {
    var p = fmt.formatToParts(new Date()), g = function (k) { for (var i = 0; i < p.length; i++) if (p[i].type === k) return +p[i].value; return 0; };
    var sec = g('hour') * 3600 + g('minute') * 60 + g('second');
    var since = (sec - START * 60 + 86400) % 86400; /* Sekunden seit Drop-Start (auch über Mitternacht) */
    var open = since < LEN * 60;
    var left = open ? LEN * 60 - since : 86400 - since;
    if (FORCE) {
      var nat = open;
      open = FORCE === 'open';
      if (open !== nat) left = open ? LEN * 60 : 86400 - since; /* nur Testmodus */
    }
    return { open: open, left: left };
  }

  function dur(s) {
    var h = Math.floor(s / 3600), m = Math.floor(s / 60) % 60, x = s % 60;
    if (h >= 1) return en ? h + 'h ' + pad(m) + 'm' : h + ' Std ' + pad(m) + ' Min';
    return pad(m) + ':' + pad(x) + (en ? '' : ' Min');
  }

  var LBL_WIN = hhmm(START) + '–' + hhmm(START + LEN) + (en ? '' : ' Uhr');
  var last = null;
  function tick() {
    var s = now();
    if (s.open !== last) {
      root.classList.toggle('gop-drop-open', s.open);
      root.classList.toggle('gop-drop-closed', !s.open);
      last = s.open;
      document.dispatchEvent(new CustomEvent('gop:drop', { detail: s }));
    }
    var cd = dur(s.left);
    document.querySelectorAll('[data-drop-cd]').forEach(function (el) { if (el.textContent !== cd) el.textContent = cd; });
    document.querySelectorAll('[data-drop-win]').forEach(function (el) { if (el.textContent !== LBL_WIN) el.textContent = LBL_WIN; });
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
